import React, { useState, useEffect, useRef } from "react";
import Spacer from "./Spacer";
import { Link } from "gatsby";
import { useStoreState, useStoreDispatch } from "../stores/index";

export default function App() {
    const [run, setRun] = useState(false);

    const app_state = useStoreState();
    const dispatch = useStoreDispatch();

    let timer_ref = useRef(null);

    useEffect(() => {
        if (run && app_state.status !== "DONE") {
            timer_ref.current = setTimeout(() => dispatch({ type: "TICK"}), 1000);
        } else {
            setRun(false);
        }
    }, [run, app_state, dispatch]);

    function pause_workout() {
        clearTimeout(timer_ref.current);
        setRun(false);
        dispatch({
            type: "PAUSE"
        });
    }

    function reset_timer() {
        clearTimeout(timer_ref.current);
        setRun(false);
        dispatch({
            type: "RESET"
        });
    }

    function start_timer() {
        setRun(true);
        dispatch({
            type: "START"
        });
    }

    return (
        <>
            <h1 className="text-capitalize">{ app_state.paused ? "paused": String(app_state.status).toLowerCase() }</h1>
            <Spacer y={4} />
            <h1>{ app_state.timer_readout }</h1>
            <button onClick={start_timer} disabled={run}>Start</button>
            {'  '}
            <button 
                onClick={pause_workout}
                disabled={!run}
            >
                Pause
            </button>
            {'  '}
            <button 
                onClick={reset_timer}
                disabled={
                    !run && 
                    (!app_state.status === "DONE" ||
                    app_state.status === "READY")
                }
            >
                Reset
            </button>
            <Spacer top={4} />
            <Link to="/settings">Settings</Link>
            <Spacer y={4} />
        </>
    )
}